const debtServiceCoverageData = [
  {
    month: ["2021", "Aug"],
    interestAndFees: null,
    debtServiceCoverageRatioFromRemittanceReport: null,
    interestExpense: 1857.44,
    cash: 836829.02,
    ebitda: -261682.45,
    debtServiceCoverageRatio: -140.88,
    runway: 3.06,
  },
  {
    month: ["2021", "Sep"],
    interestAndFees: null,
    debtServiceCoverageRatioFromRemittanceReport: null,
    interestExpense: 65731.0,
    cash: 383270.55,
    ebitda: -710855.77,
    debtServiceCoverageRatio: -10.81,
    runway: 0.49,
  },
  {
    month: ["2021", "Oct"],
    interestAndFees: null,
    debtServiceCoverageRatioFromRemittanceReport: null,
    interestExpense: 776.0,
    cash: 801144.55,
    ebitda: 29210.15,
    debtServiceCoverageRatio: 37.64,
    runway: Infinity,
  },
  {
    month: ["2021", "Nov"],
    interestAndFees: null,
    debtServiceCoverageRatioFromRemittanceReport: null,
    interestExpense: 40401.63,
    cash: 1453189.69,
    ebitda: 223837.94,
    debtServiceCoverageRatio: 5.54,
    runway: Infinity,
  },
  {
    month: ["2021", "Dec"],
    interestAndFees: null,
    debtServiceCoverageRatioFromRemittanceReport: null,
    interestExpense: 690.04,
    cash: 2093477.41,
    ebitda: -133300.42,
    debtServiceCoverageRatio: -193.18,
    runway: 15.32,
  },
  {
    month: ["2022", "Jan"],
    interestAndFees: null,
    debtServiceCoverageRatioFromRemittanceReport: null,
    interestExpense: 846.24,
    cash: 965303.76,
    ebitda: -496804.59,
    debtServiceCoverageRatio: -587.07,
    runway: 1.94,
  },
  {
    month: ["2022", "Feb"],
    interestAndFees: null,
    debtServiceCoverageRatioFromRemittanceReport: null,
    interestExpense: 39923.44,
    cash: 1371971.53,
    ebitda: -334126.64,
    debtServiceCoverageRatio: -8.37,
    runway: 3.67,
  },
  {
    month: ["2022", "Mar"],
    interestAndFees: null,
    debtServiceCoverageRatioFromRemittanceReport: null,
    interestExpense: 1031.0,
    cash: 349492.07,
    ebitda: -227476.2,
    debtServiceCoverageRatio: -220.64,
    runway: 1.53,
  },
  {
    month: ["2022", "Apr"],
    interestAndFees: null,
    debtServiceCoverageRatioFromRemittanceReport: null,
    interestExpense: 731.0,
    cash: 421236.79,
    ebitda: -474566.67,
    debtServiceCoverageRatio: -649.2,
    runway: 0.89,
  },
  {
    month: ["2022", "May"],
    interestAndFees: null,
    debtServiceCoverageRatioFromRemittanceReport: null,
    interestExpense: -3243.71,
    cash: 119722.82,
    ebitda: -283093.72,
    debtServiceCoverageRatio: 87.27,
    runway: 0.43,
  },
  {
    month: ["2022", "Jun"],
    interestAndFees: null,
    debtServiceCoverageRatioFromRemittanceReport: null,
    interestExpense: 523.0,
    cash: 412926.4,
    ebitda: -328131.99,
    debtServiceCoverageRatio: -627.4,
    runway: 1.26,
  },
  {
    month: ["2022", "Jul"],
    interestAndFees: null,
    debtServiceCoverageRatioFromRemittanceReport: null,
    interestExpense: 1565.33,
    cash: 496691.42,
    ebitda: -426064.94,
    debtServiceCoverageRatio: -272.19,
    runway: 1.17,
  },
  {
    month: ["2022", "Aug"],
    interestAndFees: null,
    debtServiceCoverageRatioFromRemittanceReport: null,
    interestExpense: 2838.51,
    cash: 299495.54,
    ebitda: -231432.52,
    debtServiceCoverageRatio: -81.53,
    runway: 1.26,
  },
  {
    month: ["2022", "Sep"],
    interestAndFees: null,
    debtServiceCoverageRatioFromRemittanceReport: null,
    interestExpense: 9397.38,
    cash: 144536.11,
    ebitda: -908612.45,
    debtServiceCoverageRatio: -96.69,
    runway: 0.16,
  },
  {
    month: ["2022", "Oct"],
    interestAndFees: null,
    debtServiceCoverageRatioFromRemittanceReport: null,
    interestExpense: 23156.44,
    cash: 511916.49,
    ebitda: -41330.69,
    debtServiceCoverageRatio: -1.78,
    runway: 7.87,
  },
  {
    month: ["2022", "Nov"],
    interestAndFees: null,
    debtServiceCoverageRatioFromRemittanceReport: null,
    interestExpense: 3362.64,
    cash: 1500152.8,
    ebitda: 996662.53,
    debtServiceCoverageRatio: 296.39,
    runway: Infinity,
  },
  {
    month: ["2022", "Dec"],
    interestAndFees: null,
    debtServiceCoverageRatioFromRemittanceReport: null,
    interestExpense: 174066.19,
    cash: 776161.2,
    ebitda: 915443.82,
    debtServiceCoverageRatio: 5.26,
    runway: Infinity,
  },
  {
    month: ["2023", "Jan"],
    interestAndFees: null,
    debtServiceCoverageRatioFromRemittanceReport: null,
    interestExpense: 2837.01,
    cash: 1496772.12,
    ebitda: -408923.78,
    debtServiceCoverageRatio: -144.14,
    runway: 3.64,
  },
  {
    month: ["2023", "Feb"],
    interestAndFees: null,
    debtServiceCoverageRatioFromRemittanceReport: null,
    interestExpense: 2760.31,
    cash: 35759.9,
    ebitda: -437982.85,
    debtServiceCoverageRatio: -158.67,
    runway: 0.08,
  },
  {
    month: ["2023", "Mar"],
    interestAndFees: null,
    debtServiceCoverageRatioFromRemittanceReport: null,
    interestExpense: 3230.14,
    cash: 330112.56,
    ebitda: -268249.95,
    debtServiceCoverageRatio: -83.05,
    runway: 1.21,
  },
  {
    month: ["2023", "Apr"],
    interestAndFees: 0.0,
    debtServiceCoverageRatioFromRemittanceReport: -Infinity,
    interestExpense: 3185.9,
    cash: 834658.4,
    ebitda: -362322.35,
    debtServiceCoverageRatio: -113.73,
    runway: 2.28,
  },
  {
    month: ["2023", "May"],
    interestAndFees: 9375.0,
    debtServiceCoverageRatioFromRemittanceReport: -14.74,
    interestExpense: 3549.75,
    cash: 1189551.45,
    ebitda: -138217.53,
    debtServiceCoverageRatio: -38.94,
    runway: 8.36,
  },
  {
    month: ["2023", "Jun"],
    interestAndFees: 18750.0,
    debtServiceCoverageRatioFromRemittanceReport: -5.89,
    interestExpense: 3545.98,
    cash: 853773.23,
    ebitda: -110445.3,
    debtServiceCoverageRatio: -31.15,
    runway: 7.46,
  },
  {
    month: ["2023", "Jul"],
    interestAndFees: 18750.0,
    debtServiceCoverageRatioFromRemittanceReport: -13.94,
    interestExpense: 3601.23,
    cash: 565946.54,
    ebitda: -261339.09,
    debtServiceCoverageRatio: -72.57,
    runway: 2.13,
  },
  {
    month: ["2023", "Aug"],
    interestAndFees: 26096.24,
    debtServiceCoverageRatioFromRemittanceReport: 18.35,
    interestExpense: 66779.46,
    cash: 1051243.87,
    ebitda: 478974.27,
    debtServiceCoverageRatio: 7.17,
    runway: Infinity,
  },
  {
    month: ["2023", "Sep"],
    interestAndFees: 32677.31,
    debtServiceCoverageRatioFromRemittanceReport: -10.11,
    interestExpense: 3210.5,
    cash: 229324.62,
    ebitda: -330344.04,
    debtServiceCoverageRatio: -102.89,
    runway: 0.69,
  },
  {
    month: ["2023", "Oct"],
    interestAndFees: 31129.9,
    debtServiceCoverageRatioFromRemittanceReport: 6.9,
    interestExpense: 45358.29,
    cash: 1177695.44,
    ebitda: 214908.24,
    debtServiceCoverageRatio: 4.74,
    runway: Infinity,
  },
  {
    month: ["2023", "Nov"],
    interestAndFees: 29547.99,
    debtServiceCoverageRatioFromRemittanceReport: 35.45,
    interestExpense: 1648.92,
    cash: 2753910.17,
    ebitda: 1047403.41,
    debtServiceCoverageRatio: 635.21,
    runway: Infinity,
  },
  {
    month: ["2023", "Dec"],
    interestAndFees: 27930.82,
    debtServiceCoverageRatioFromRemittanceReport: 40.91,
    interestExpense: 468814.25,
    cash: 2623131.82,
    ebitda: 1142678.98,
    debtServiceCoverageRatio: 2.44,
    runway: Infinity,
  },
  {
    month: ["2024", "Jan"],
    interestAndFees: 26277.59,
    debtServiceCoverageRatioFromRemittanceReport: -10.96,
    interestExpense: 1310.01,
    cash: 2138036.21,
    ebitda: -288098.75,
    debtServiceCoverageRatio: -219.92,
    runway: 7.35,
  },
  {
    month: ["2024", "Feb"],
    interestAndFees: 24587.5,
    debtServiceCoverageRatioFromRemittanceReport: -1.11,
    interestExpense: 80485.11,
    cash: 1564853.85,
    ebitda: -27314.47,
    debtServiceCoverageRatio: -0.34,
    runway: 14.11,
  },
  {
    month: ["2024", "Mar"],
    interestAndFees: 22859.73,
    debtServiceCoverageRatioFromRemittanceReport: -5.69,
    interestExpense: 1169.03,
    cash: 1221752.51,
    ebitda: -130093.38,
    debtServiceCoverageRatio: -111.28,
    runway: 9.04,
  },
  {
    month: ["2024", "Apr"],
    interestAndFees: 21093.44,
    debtServiceCoverageRatioFromRemittanceReport: -10.79,
    interestExpense: 1238.81,
    cash: 419327.05,
    ebitda: -227585.66,
    debtServiceCoverageRatio: -183.71,
    runway: 1.81,
  },
  {
    month: ["2024", "May"],
    interestAndFees: 47246.96,
    debtServiceCoverageRatioFromRemittanceReport: 2.72,
    interestExpense: 81073.4,
    cash: 1758261.13,
    ebitda: 128549.29,
    debtServiceCoverageRatio: 1.59,
    runway: Infinity,
  },
  {
    month: ["2024", "Jun"],
    interestAndFees: 10455.05,
    debtServiceCoverageRatioFromRemittanceReport: -13.91,
    interestExpense: 10220.65,
    cash: 1325360.54,
    ebitda: -145428.41,
    debtServiceCoverageRatio: -14.23,
    runway: 8.31,
  },
  {
    month: ["2024", "Jul"],
    interestAndFees: 9521.92,
    debtServiceCoverageRatioFromRemittanceReport: -55.51,
    interestExpense: 1135.89,
    cash: 456598.43,
    ebitda: -528576.95,
    debtServiceCoverageRatio: -465.34,
    runway: 0.86,
  },
  {
    month: ["2024", "Aug"],
    interestAndFees: 8567.97,
    debtServiceCoverageRatioFromRemittanceReport: 2.66,
    interestExpense: 1059.81,
    cash: 515308.36,
    ebitda: 22798.87,
    debtServiceCoverageRatio: 21.51,
    runway: Infinity,
  },
  {
    month: ["2024", "Sep"],
    interestAndFees: 7592.76,
    debtServiceCoverageRatioFromRemittanceReport: -39.8,
    interestExpense: 178670.64,
    cash: 474504.22,
    ebitda: -302181.54,
    debtServiceCoverageRatio: -1.69,
    runway: 0.98,
  },
  {
    month: ["2024", "Oct"],
    interestAndFees: 6595.81,
    debtServiceCoverageRatioFromRemittanceReport: -25.3,
    interestExpense: 925.0,
    cash: 980222.92,
    ebitda: -166876.94,
    debtServiceCoverageRatio: -180.41,
    runway: 5.98,
  },
  {
    month: ["2024", "Nov"],
    interestAndFees: 5576.63,
    debtServiceCoverageRatioFromRemittanceReport: 162.26,
    interestExpense: 76858.23,
    cash: 1696292.61,
    ebitda: 904849.13,
    debtServiceCoverageRatio: 11.77,
    runway: Infinity,
  },
  {
    month: ["2024", "Dec"],
    interestAndFees: 4534.73,
    debtServiceCoverageRatioFromRemittanceReport: 152.13,
    interestExpense: 584236.92,
    cash: 2574967.8,
    ebitda: 689865.96,
    debtServiceCoverageRatio: 1.18,
    runway: Infinity,
  },
  {
    month: ["2025", "Jan"],
    interestAndFees: 3469.6,
    debtServiceCoverageRatioFromRemittanceReport: -156.27,
    interestExpense: 876.22,
    cash: 1584024.86,
    ebitda: -542199.64,
    debtServiceCoverageRatio: -618.79,
    runway: 2.92,
  },
  {
    month: ["2025", "Feb"],
    interestAndFees: 1113.16,
    debtServiceCoverageRatioFromRemittanceReport: -40.15,
    interestExpense: 864.76,
    cash: 1647578.58,
    ebitda: -44694.79,
    debtServiceCoverageRatio: -51.68,
    runway: 33.48,
  },
  {
    month: ["2025", "Mar"],
    interestAndFees: 10625.0,
    debtServiceCoverageRatioFromRemittanceReport: 10.56,
    interestExpense: 773.75,
    cash: 2455371.49,
    ebitda: 112243.9,
    debtServiceCoverageRatio: 145.06,
    runway: Infinity,
  },
  {
    month: ["2025", "Apr"],
    interestAndFees: 10625.0,
    debtServiceCoverageRatioFromRemittanceReport: -39.08,
    interestExpense: 836.9,
    cash: 1704202.32,
    ebitda: -415232.58,
    debtServiceCoverageRatio: -496.16,
    runway: 4.06,
  },
  {
    month: ["2025", "May"],
    interestAndFees: 10625.0,
    debtServiceCoverageRatioFromRemittanceReport: -10.22,
    interestExpense: 792.94,
    cash: 1753981.91,
    ebitda: -108584.43,
    debtServiceCoverageRatio: -136.94,
    runway: 15.63,
  },
  {
    month: ["2025", "Jun"],
    interestAndFees: 29575.73,
    debtServiceCoverageRatioFromRemittanceReport: 12.9,
    interestExpense: 804.66,
    cash: 1661007.56,
    ebitda: 381408.26,
    debtServiceCoverageRatio: 474.0,
    runway: Infinity,
  },
  {
    month: ["2025", "Jul"],
    interestAndFees: 28708.54,
    debtServiceCoverageRatioFromRemittanceReport: 0.76,
    interestExpense: 0.0,
    cash: 1684309.07,
    ebitda: 21769.13,
    debtServiceCoverageRatio: Infinity,
    runway: Infinity,
  },
];

export default debtServiceCoverageData;
